export enum PriceStatus {
  Reasonable = "Reasonable",
  Normal = "Normal",
  HighEnd = "HighEnd",
}

export const genPriceStatusName = (price_status: string) => {
  switch (price_status) {
    case PriceStatus.Reasonable:
      return "リーズナブル";
    case PriceStatus.Normal:
      return "ノーマル";
    case PriceStatus.HighEnd:
      return "ハイエンド";
    default:
      return "－";
  }
};
